import React from 'react';
import imgImage7 from '../../assets/sections/00d14b12320dbdbd6d51dff62ccdcdf99257c5cf.png';
import imgImage33 from '../../assets/sections/e6894abff404d30e96485a2c4089d3ae201bb3bb.png';
import imgTopcvLogoOnDarkBlue1 from '../../assets/sections/841adb0c872226490c5e44a0aa3bc15f7d074ad7.png';
import imgImage35 from '../../assets/sections/e372807c1a50a8042bcc3dcf8766d54111cc8c5c.png';
import imgImage36 from '../../assets/sections/8ac0c64c7c715f2c436796d24ce7482e11faaf8b.png';
import imgImage37 from '../../assets/sections/09d9396a301f711db95e5a1d92de397c9cc6c1df.png';
import imgTopcvLogoOnDarkBlue1Vectorized from '../../assets/sections/2d8b04c337578f07f465a567d97cce33c647d6f2.svg';
import imgVector from '../../assets/sections/79637c526f50b32b81c4d633391ee1a9a4eb618a.svg';
import imgVector1 from '../../assets/sections/c1697e76dba29642cec5aa0198d8b1c00dbda0a7.svg';
import imgRectangle63 from '../../assets/sections/5cd2fcbe434701b73b7499c181e0e9947a7730ce.svg';


export default function Livestream() {
  return (
    <div className="relative w-[1920px] h-[1042px]" data-node-id="204:10">
      <div className="absolute h-[1042px] left-0 top-0 w-[1925px]" data-name="image 7" data-node-id="204:11">
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 overflow-hidden">
            <img alt="" className="absolute h-[103.84%] left-0 max-w-none top-0 w-[99.98%]" src={imgImage7} />
          </div>
          <div className="absolute bg-white inset-0" />
        </div>
      </div>
      <div className="absolute inset-[41.94%_-16.41%_13.33%_59.32%]" data-name="TOPCV_LOGO_ON-DARK-BLUE 1 [Vectorized]" data-node-id="226:210">
        <img alt="" className="absolute block max-w-none size-full" src={imgTopcvLogoOnDarkBlue1Vectorized} />
      </div>
      <div className="cursor-pointer absolute bg-gradient-to-r content-stretch flex from-[#01b150] h-[80px] items-center justify-center left-[134px] px-[19px] py-[14px] rounded-[16px] shadow-[0px_24px_84px_0px_rgba(0,255,114,0.3)] to-[#00474b] top-[741px] w-[245px]" data-name="Discount container" data-node-id="204:12"
        onClick={() => {
          window.open("https://docs.google.com/forms/d/1bN6xT8FaU0fXrQ6QYZEpMYB3rgZ6Lh8hhc9ccg5xbBQ/viewform", "_blank")
        }}

      >
        <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[21px] text-center text-white whitespace-nowrap" data-node-id="204:13">
          KHÁM PHÁ NGAY
        </p>
      </div>
      <div className="absolute content-stretch flex flex-col gap-[43px] items-start left-[134px] top-[365px] w-[1081px]" data-node-id="204:42">
        <div className="content-stretch flex flex-col items-start relative shrink-0 w-full" data-node-id="204:21">
          <div className="font-['Alexandria',sans-serif] font-bold leading-[0] relative shrink-0 text-[#002e2a] text-[65px] uppercase whitespace-nowrap" data-node-id="204:23">
            <p className="leading-[84px] mb-0 whitespace-pre">{`Livestream tuyển dụng `}</p>
            <p className="leading-[84px] whitespace-pre">Việc làm Hải Phòng</p>
          </div>
        </div>
        <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-[745px]" data-node-id="204:14">
          <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full" data-node-id="204:15">
            <div className="overflow-clip relative shrink-0 size-[32px]" data-name="Bold / Time / Alarm" data-node-id="204:16">
              <div className="absolute inset-[8.33%_12.5%]">
                <img alt="" className="absolute block max-w-none size-full" src={imgVector} />
              </div>
            </div>
            <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#002e2a] text-[32px] whitespace-nowrap" data-node-id="204:17">
              Thời gian: 09.04.2026
            </p>
          </div>
          <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full" data-node-id="204:18">
            <div className="overflow-clip relative shrink-0 size-[32px]" data-name="Bold / Map & Location / Map Point" data-node-id="204:19">
              <div className="absolute inset-[8.33%_16.67%]">
                <img alt="" className="absolute block max-w-none size-full" src={imgVector1} />
              </div>
            </div>
            <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#002e2a] text-[32px] whitespace-nowrap" data-node-id="204:20">{`Nền tảng: Fanpage, TikTok & Website TopCV`}</p>
          </div>
        </div>
      </div>
      <div className="absolute contents left-[1035px] top-[-3px]" data-node-id="204:43">
        <div className="absolute h-[1045px] left-[1035px] top-[-3px] w-[836px]" data-name="image 33" data-node-id="204:35">
          <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage33} />
        </div>
        <div className="absolute h-[219.223px] left-[1288.3px] top-[235.53px] w-[273.745px]" data-node-id="204:38">
          <img alt="" className="absolute block max-w-none size-full" src={imgRectangle63} />
        </div>
        <div className="absolute h-[84.054px] left-[1334.87px] top-[303.68px] w-[180.603px]" data-name="TOPCV_LOGO_ON-DARK-BLUE 1" data-node-id="204:40">
          <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgTopcvLogoOnDarkBlue1} />
        </div>
      </div>
      <p className="absolute font-['Alexandria',sans-serif] font-normal leading-[normal] left-[134px] opacity-50 text-[#002e2a] text-[32px] top-[300px] w-[1081px]" data-node-id="204:48">
        LIVESTREAM
      </p>
      <div className="absolute left-[994px] pointer-events-none size-[290px] top-[33px]" data-name="image 35" data-node-id="222:62">
        <img alt="" className="absolute inset-0 max-w-none object-cover size-full" src={imgImage35} />
        <div className="absolute inset-0 rounded-[inherit] shadow-[inset_4px_5px_14px_0px_rgba(255,255,255,0.25)]" />
      </div>
      <div className="absolute h-[89px] left-[1622px] pointer-events-none top-[191px] w-[147px]" data-name="image 36" data-node-id="222:65">
        <img alt="" className="absolute inset-0 max-w-none object-cover size-full" src={imgImage36} />
        <div className="absolute inset-0 rounded-[inherit] shadow-[inset_0px_9px_10.7px_0px_rgba(255,255,255,0.25)]" />
      </div>
      <div className="absolute left-[1325px] size-[330px] top-[-30px]" data-name="image 37" data-node-id="223:77">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage37} />
      </div>
    </div>
  );
}
